import Highcharts from "highcharts";
import { CurrencyFormatter } from "../chartHelper";
import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const PROJECT_MONITORED_DASHBOARD_CHART_HELPER = data => {
  const BAR_CHART_CONFIG = {
    chart: {
      ...chartConfig.chart,
      zoomType: "xy",
      renderTo: "bar-chart",
      className: "chart-background",
      spacingBottom: 15,
      animation: {
        duration: 9000
      },
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.FIRST_PAGE.FIRST._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      text: ""
    },
    xAxis: [
      {
        categories: [],
        className: "bar-label",
        /*lineWidth: 1,
                lineColor: "#3782DE",*/
        alignTicks: true,
        labels: {
          autoRotation: [-90],
          formatter: function() {
            return this.value;
          },
          style: {
            "font-weight": "300"
          }
        }
      }
    ],
    yAxis: [
      {
        // Primary yAxis
        labels: {
          format: `{value}`,
          style: {
            "font-weight": "300"
          }
        },
        title: {
          text: "Number of Project(s)",
          style: {
            color: "black"
          }
        },
        min: 0,
        max: 0,
        className: "bar-label",
        /*lineWidth: 1,
                lineColor: "#3782DE",*/
        alignTicks: true
      },
      {
        // Secondary yAxis
        title: {
          text: "Total Investments (Lakh Cr.)",
          style: {
            color: "black"
          }
        },
        labels: {
          formatter: function() {
            return CurrencyFormatter(this.value / 100000).replace(/,/g, ".");
          },
          style: {
            "font-weight": "300"
          }
        },
        min: 0,
        max: 0,
        opposite: true,
        className: "bar-label"
      }
    ],
    tooltip: {
      shared: true,
      // pointFormat: `{series.name}: <b>{point.y}</b><br/>`
      formatter: function() {
        const { points } = this;
        return `
                <b>Projects: ${points[0].y}</b><br />
                <b>Cost: ${CurrencyFormatter(points[1].y / 100000)} Lakh Cr</b>
              `;
      }
    },
    legend: {
      verticalAlign: "bottom",
      layout: "horizontal",
      align: "center",
      symbolRadius: 0,
      itemStyle: {
        color: "black"
      },
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || // theme
        "rgba(255,255,255,0.25)"
    },
    series: [
      {
        name: "PMG Monitored Project(s)",
        type: "spline",
        yAxis: 0,
        zIndex: 1,
        data: [],
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          style: {
            textOutline: "none"
          }
        },
        color: "#EA833A"
      },
      {
        name: "Total Investments (Lakh Cr.)",
        type: "column",
        data: [],
        yAxis: 1,
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          position: "center",
          verticalAlign: "middle",
          inside: true,
          rotation: -90,
          formatter: function() {
            return CurrencyFormatter(this.y)
              .substr(0, 5)
              .replace(/,/g, ".");
          },
          style: {
            textOutline: "none",
            color: "#fff"
          }
        },
        color: "#2D79D3"
      }
    ],
    plotOptions: {
      series: {
        animation: true,
        //borderRadius: 5,
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      }
    }
  };

  // extract data for charts
  const extractData = { year: [], count: [], cost: [] };
  data.forEach(({ year, count, cost }) => {
    extractData.year.push(year);
    extractData.count.push(count);
    extractData.cost.push(cost);
  });
  // set data
  //const maxYLeftAxis = Math.max(...extractData.count);
  //
  // BAR_CHART_CONFIG.yAxis[0].tickPositions = [];
  // for (let i = 0; i < maxYLeftAxis; i += 200) {
  //   BAR_CHART_CONFIG.yAxis[0].tickPositions.push(i);
  // }

  BAR_CHART_CONFIG.xAxis[0].categories = extractData.year;
  BAR_CHART_CONFIG.series[0].data = extractData.count;
  BAR_CHART_CONFIG.series[1].data = extractData.cost;
  BAR_CHART_CONFIG.yAxis[0].max = Math.max(...extractData.count);
  BAR_CHART_CONFIG.yAxis[0].tickAmount = 6;
  BAR_CHART_CONFIG.yAxis[1].max = Math.max(...extractData.cost);
  BAR_CHART_CONFIG.yAxis[1].tickAmount = 6;

  return BAR_CHART_CONFIG;
};
